import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ConfigState } from './config.state';

// selectors
export const selectConfigModule = createFeatureSelector<ConfigState>('config');
export const selectConfig = createSelector(selectConfigModule, (state: ConfigState) => state.config);




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/config/config.selector.ts